import { render, staticRenderFns } from "./triggerRule.vue?vue&type=template&id=206dccd4&scoped=true&"
import script from "./triggerRule.vue?vue&type=script&lang=ts&"
export * from "./triggerRule.vue?vue&type=script&lang=ts&"
import style0 from "./triggerRule.vue?vue&type=style&index=0&id=206dccd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206dccd4",
  null
  
)

export default component.exports